import Button from '@/components/ui/Button';

const CTAButtons = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Button 
        variant="primary"
        onClick={() => scrollToSection('pricing')}
      >
        Dołączam do programu
      </Button>
      <Button 
        variant="secondary" 
        className="bg-white text-dark hover:bg-white/90"
        onClick={() => scrollToSection('co-otrzymasz')}
      >
        Zobacz ofertę
      </Button>
    </div>
  );
};

export default CTAButtons;